const breakPointPC = 1279;
const breakPointSP = 767;
let resizeFlag     = false;
let windowWidth    = window.innerWidth;
let windowHeight   = window.innerHeight;
let windowWidthJ   = $(window).width();





// ------------------------------------------------------------------------
// visibleButton
// ----- BOTH
// ------------------------------------------------------------------------
const visibleButton = () => {
  let targetButton = document.querySelector('.sw-Top');
  let targetHeight = 100;
  window.addEventListener('scroll', () => {
    let scrollHeight = window.pageYOffset;
    if (scrollHeight > targetHeight) {
      targetButton.classList.remove('is-Hidden');
    } else {
      targetButton.classList.add('is-Hidden');
    }
  });
}



// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};




// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const mainNavCurrent = () => {
  $(function () {
    var href = window.location.href;
    $('nav ul li').each(function(i){
      var url = $(this).children('a').prop('href')
      if (href === url) {
        $(this).children('a').addClass('current');
      } else {
        $(this).children('a').removeClass('current');
      }
    });
  });
};



// ------------------------------------------------------------------------
// modalPopup
// ----- BOTH
// ------------------------------------------------------------------------
const modalPopup = () => {
  $(function () {
    $('nav li:last-of-type').click(function(){
      $('.st-Footer_Modal').fadeIn();
    });
    $('.close-modal , .modal-bg').click(function(){
      $('.st-Footer_Modal').fadeOut();
    });
  });
};


// ------------------------------------------------------------------------
// mhowMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {
  const $modal = $('#movie-Stage');
  const $content = $('#movie-Iframe');

  // open
  $('.js-Youtube').on('click', function(){

    const dataID = $(this).attr('data-youtube');

    $('#movie-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){
      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;
    });

  });

  //close
  $('#movie-Close,#movie-Iframe').on('click', function(){

    $('#movie-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#movie-Stage').css({'display':'none'});
      $content.children('iframe').remove();
		});
    //
    // $modal.stop().fadeOut(300, function(){
    //   $content.children('iframe').remove();
    // });
  });

};




export {
  visibleButton,
  anchorLink,
  mainNavCurrent,
  modalPopup,
  showMovie,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js